import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-c920e2f4")

_pushScopeId("data-v-c920e2f4")
const _hoisted_1 = { class: "main__section" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ReqeustResponse = _resolveComponent("ReqeustResponse")

  return (_openBlock(), _createBlock("main", null, [
    _createVNode("section", _hoisted_1, [
      _createVNode(_component_ReqeustResponse, {
        id: _ctx.state.id,
        kind: _ctx.RequestKindTypes.OnlineCare
      }, null, 8, ["id", "kind"])
    ])
  ]))
})